import { keepPreviousData, useQuery } from "@tanstack/react-query";
import * as Immutable from "immutable";
import { StreamDestinationsFilters } from "@graylog/server-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
export const KEY_PREFIX = ["streams", "output", "filters"];
export const keyFn = (streamId, destinationType, pagination) => [
  ...KEY_PREFIX,
  streamId,
  destinationType != null ? destinationType : "all",
  pagination
];
const defaultParams = { page: 1, perPage: 10, query: "" };
export const fetchStreamOutputFilters = async (streamId, pagination) => StreamDestinationsFilters.getPaginatedFiltersForStream(
  streamId,
  pagination.query || void 0,
  pagination.page,
  pagination.perPage
).then((response) => {
  const { elements, query, total, page, per_page: perPage, count } = response;
  return {
    list: Immutable.List(elements),
    attributes: [],
    pagination: {
      total,
      page,
      perPage,
      query,
      count
    }
  };
});
const useStreamOutputFilters = (streamId, destinationType, pagination = defaultParams) => {
  const { data, refetch, isLoading, isSuccess } = useQuery({
    queryKey: keyFn(streamId, destinationType, pagination),
    queryFn: () => defaultOnError(
      fetchStreamOutputFilters(streamId, {
        ...pagination,
        query: destinationType ? `destination_type:${destinationType}` : pagination.query
      }),
      i18n.t("stream_hooks.load_output_filters_failed", { ns: "streams" }),
      i18n.t("stream_hooks.load_output_filters_failed_title", { ns: "streams" })
    ),
    placeholderData: keepPreviousData
  });
  return {
    data,
    refetch,
    isLoading,
    isSuccess
  };
};
export default useStreamOutputFilters;
